<template>
    <div class="wrapper" style="min-height: 120px">
        <table class="table data-table container" :class="{'deallist': $attrs.deallist}">
            <ClipLoader color="#394956" class="loader" v-if="dataLoading"></ClipLoader>
            <thead>
            <draggable v-model="headers" tag="tr">
                <th v-if="selectableRows" style="min-width:50px;max-width:50px !important; width:50px;!important"
                    class="cbx_all">
                    <Checkbox id="cbx_all" title="" v-model="cbx_all" style="margin-right: 10px;"></Checkbox>
                </th>
                <th v-for="column in headers.filter(x=> x.name !== 'checkbox')" :key="column.name" scope="col"
                    @click="$emit('sort', column.name)"
                    v-tooltip="column.tooltip ? column.tooltip : null"
                    :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc')
                        : 'sorting'"
                    :style="{width: column.width, cursor: 'pointer', maxWidth:column.maxWidth}">
                    <div class="tablehead">
                        {{ column.label }}
                        <span v-if="typeof column.noSort === 'undefined' || column.noSort === false"
                              :class="[sortKey === column.name ? (sortOrders[column.name] > 0 ? 'icon-sort-up' : 'icon-sort-down') : 'icon-sort-default', 'sortKey']"></span>
                    </div>
                </th>
            </draggable>
            </thead>
            <slot v-if="this.client && !dataLoading"></slot>
            <tbody v-else-if="!this.client && !dataLoading">
            <tr v-for="(row,index) in rows" :key="'row'+index"
                :class="{'missingDealID': typeof row.deal_id !== 'undefined' && row.deal_id === null && $attrs.deallist}">
                <td :class="col.name" v-for="col in headers" :key="col.name+'-row'"
                    @click="emitClick($event, col.name, row)">
                    <Checkbox v-if="col.name === 'checkbox'" :id="'cbx_'+index" title="" v-model="checkboxes[row.id]"
                              style="margin-right: 10px;" @change="cbxChange($event, row.id)"></Checkbox>
                    <div v-else-if="$attrs.deallist && col.name === 'end'">
                        {{ row.end ? moment(row.end).format('DD.MM.YYYY') : 'always on' }}
                    </div>
                    <div v-else-if="$attrs.deallist && col.name === 'start'">
                        {{ moment(row.start).format('DD.MM.YYYY') }}
                    </div>
                    <StatusDot v-else-if="col.name === 'status' || col.name === 'sub_status'" v-bind="$attrs"
                               :info="getDataForDynamicLink(col.name, row)" :statusKey="col.name" :exclamation="col.name === 'sub_status'"></StatusDot>
                    <div v-else-if="col.name === 'deallist_status'" style="display: flex; justify-content: center">
                        <span v-if="row.end && (new Date > new Date(row.end)) || row.is_archived === 1"
                              class="icon icon-status-alarm" style="color:#EF6C00"
                              v-tooltip="row.is_archived === 1 ? 'Archiviert' : 'End Datum wurde überschritten'">
                        </span>
                        <div v-else></div>
                    </div>
                    <div v-else-if="col.name === 'action' && $attrs.showActionCol"
                         style="display: flex; justify-content: center">
                        <span class="icon icon-delete" style="color:red" @click.stop="$emit('action:delete', row)"
                              v-tooltip="'Deal löschen'"></span>
                    </div>
                    <DynamicLink v-else :data="getDataForDynamicLink(col.name, row)"></DynamicLink>
                </td>
            </tr>
            </tbody>
            <div v-if="!this.client && rows.length === 0 && !dataLoading" class="noData">Keine Daten</div>
        </table>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import DynamicLink from "./DynamicLink";
import StatusDot from "./StatusDot";
import Checkbox from "@/components/inputs/Checkbox";

export default {
    props: {
        columns: Array,
        sortKey: String,
        sortOrders: Object,
        rows: Array,
        transformers: {
            $each: {
                validator: function (value) {
                    return value.propName && value.transform
                }
            }
        },
        dataLoading: {
            type: Boolean,
            default: false
        },
        client: {
            type: Boolean,
            default: false
        },
        selectableRows: {type: Boolean, default: false},
    },
    components: {Checkbox, StatusDot, DynamicLink, draggable},
    data() {
        return {
            headers: [],
            checkboxes: {},
            cbx_all: false,
            ignore_cbx_all_change: false,
            loadedOnce: false,
        }
    },
    mounted() {
        this.headers = JSON.parse(JSON.stringify(this.columns));
        if (JSON.stringify(this.$store.state.deallist.selectedRows) !== JSON.stringify(this.checkboxes)) {
            this.checkboxes = this.$store.state.deallist.selectedRows;
        }
        if (this.selectableRows) {
            this.headers.unshift({
                label: '',
                name: 'checkbox'
            });
        }
    },
    methods: {
        transform: function (propName, row) {
            let value = row[propName];
            let transformer = this.getTransformer(propName);
            if (!transformer) {
                return value;
            } else {
                return transformer.transform(value, row);
            }
        },

        getTransformer: function (propName) {
            if (typeof this.transformers === 'undefined') {
                return null;
            }
            let transformer = null;
            for (let i = 0; i < this.transformers.length; i++) {
                if (this.transformers[i].propName === propName) {
                    transformer = this.transformers[i];
                    break;
                }
            }
            return transformer;
        },
        emitClick(event, col, row) {
            this.$emit('rowClicked', {event: event, column: col, row: row, rows: this.rows});
        },
        getDataForDynamicLink(colName, row) {
            return {
                column: this.columns.find(x => x.name === colName),
                row: row,
                text: this.transform(colName, row)
            }
        },
        convert(colname, row) {
            let col = this.columns.find(x => x.name === colname);
            if (typeof col.route !== "undefined") {
                let ret = `<router-link :to="{ name: '${col.route.name}'`;
                if (typeof col.route.params !== "undefined") {
                    ret += `, params: ${row[col.route.params]}`;
                }
                ret += `}"`;
                return ret;
            } else {
                return row[colname];
            }
            //return '<div>' + str.replace(/#([\w]+)/g, '<router-link to="/tag/$1">#$1</router-link>') + '</div>'
        },
        getDeallistStatus(row) {
            if (row.end && (new Date > new Date(row.end)) || row.is_archived === 1) {
                return '<div v-tooltip="toolTip" title="' + (row.is_archived === 1 ? 'Archiviert' : 'End Datum wurde überschritten') + '" class="icon icon-status-alarm" style="color:#EF6C00"></div>';
            }
        },
        cbxChange(value, id) {
            this.checkboxes[id] = value;
            this.$emit('selected', this.checkboxes);
            if (this.cbx_all) {
                this.ignore_cbx_all_change = true;
                this.cbx_all = false;
            }
        }
    },
    watch: {
        cbx_all(newValue) {
            this.$emit('cbx_all', newValue);
            if (this.selectableRows) {
                if (this.ignore_cbx_all_change) {
                    this.ignore_cbx_all_change = false;
                } else {
                    if (this.cbx_all) {
                        this.rows.forEach((row) => {
                            this.checkboxes[row.id] = true;
                        });
                        Object.keys(this.checkboxes).forEach((id) => {
                            this.checkboxes[id] = true;
                        });
                    } else {
                        Object.keys(this.checkboxes).forEach((id) => {
                            this.checkboxes[id] = false;
                        });
                    }
                    this.$emit('selected', this.checkboxes);
                }
            }
        },
        rows() {
            /*if (this.selectableRows) {
                if (this.cbx_all) {
                    this.rows.forEach((row) => {
                        this.checkboxes[row.id] = true;
                    })
                }
                this.$emit('selected', this.checkboxes);
            }*/
            //add new rows to this.checkboxes
            if (this.loadedOnce) {
                this.rows.forEach((row) => {
                    if (typeof this.checkboxes[row.id] === "undefined") {
                        this.checkboxes[row.id] = false;
                    }
                })
                let allChecked = true;
                for (let i = 0; i < this.rows.length; i++) {
                    if (this.checkboxes[this.rows[i].id] === false) {
                        allChecked = false;
                        break;
                    }
                }
                if (this.cbx_all !== allChecked) {
                    this.ignore_cbx_all_change = true;
                    this.cbx_all = allChecked;
                }
            } else {
                this.loadedOnce = true;
            }
        }
    },

}
</script>

<style scoped lang="scss">
@import "../../assets/styles/variables.scss";

table {
    white-space: nowrap;
    width: 100%;

    .td {
        padding: 10px;
    }

    tr {
        height: 40px;

        th .tablehead {
            padding: 2px 10px;
        }

        th:not(:last-child) {
            .tablehead {
                border-right: 2px #fff dotted;
            }
        }
    }

    th span.sortKey {
        margin-left: 5px;
        font-size: 14px;
    }

}

table.table.data-table {
  :deep(td a) {
        display: flex;
        text-decoration: none;
        color: #394956;
        padding: 10px;

        span.placeholder {
            height: 18px;
        }
    }

}

.container td {
    font-weight: normal;
    font-size: 1em;
}

.container {
    text-align: left;
    // overflow: hidden;
    //  width: 80%;
    margin: 0 auto;
    display: table;
    border-spacing: 0;
    //padding: 1em 0 1em 0;
    padding-bottom: 1em;
}

/* Background-color of the odd rows */
.container tr:nth-child(odd) {
    background-color: #f6f7f8;
}

/* Background-color of the even rows */
.container tr:nth-child(even) {
    background-color: #fff;
}

.container tr:hover {
    background-color: #eceef0;
}

.container thead tr {
    color: #fff;
    background: #00b6ed;
    background: linear-gradient(90deg, #00b6ed, #5c4991 75%, #7f4293);
}


@media (max-width: 800px) {
    .container td:nth-child(4),
    .container th:nth-child(4) {
        display: none;
    }
}

.table {
    //overflow-x: scroll;
}

.wrapper {
    overflow-x: auto;
    width: 100%;
    margin-bottom: 1rem;
}

::-webkit-scrollbar {
    width: 14px;
    height: 18px;
}

::-webkit-scrollbar-thumb:horizontal {
    height: 6px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 10px;
    background-color: #d0d4da;
    -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}

::-webkit-scrollbar-button:horizontal {
    width: 0;
    height: 0;
    display: none;
}

::-webkit-scrollbar-corner:horizontal {
    background-color: #000000;
}

.loader {
    position: absolute;
    left: 50%;
    margin-top: 1rem;
}

.noData {
    width: 100%;
    position: absolute;
    display: flex;
    background: #f6f7f8;
    padding: 10px;
    justify-content: center;
}

.status {
    text-align: center;
}

.deallist {
  :deep( .circle) {
        &:before {
            content: ' \25CF';
            font-size: 2em;
        }

        &.red {
            color: #FF001A;
        }

        &.yellow {
            color: #F9CE1D;
        }

        &.green {
            color: #81C784;
        }
    }
}
.cbx_all :deep( .state.p-primary) {
    background: #fff;
}
</style>